exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header__left{width:50%;float:left;padding-right:25px}@media (max-width:768px){.header__left{width:100%;padding-right:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0dfa1de0","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/main-survey/survey-step4-q3.vue
// module id = 843
// module chunks = 0